
import { apiSlice } from "../apiSlice";
import { updateUser, userLogin, userLogout, userRegistration } from "./authSlice";

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    register: builder.mutation({
      query: (data) => ({
        url: "/auth/signin",
        method: "POST",
        body: data,
        credentials: "include",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;

        } catch (error) {
          console.log(error);
        }
      },
    }),
    verifyToken: builder.mutation({
      query: (token) => ({
        url: "/auth/verifytoken",
        method: "GET",
        credentials: "include",

        headers: {
          // Add your custom headers here
          "authorization": `bearer ${token}`,
        },
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          const token = result.data?.response?.newToken;
          localStorage.setItem('knighthuntToken', token);
          localStorage.setItem('knighthuntUserInfo', JSON.stringify(result?.data?.additional?.userData));

          dispatch(
            userLogin({
              acessToken: token,
              user: result.data.additional?.userData,
            })
          );
        } catch (error) {
          console.log(error);
        }
      },
    }),
    login: builder.mutation({
      query: (data) => ({
        url: "/auth/adminsignin",

        method: "POST",
        body: data,
        credentials: "include",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          console.log('result', result)



        } catch (error) {
          console.log(error);
        }
      },
    }),
    socialLogin: builder.mutation({
      query: (data) => ({
        url: "social-auth",
        method: "POST",
        body: data,
        credentials: "include",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const result = await queryFulfilled;
          dispatch(
            userLogin({
              acessToken: result.data.accessToken,
              user: result.data.user,
            })
          );
        } catch (error) {
          console.log(error);
        }
      },
    }),
    logout: builder.mutation({
      query: () => ({
        url: "auth/logout",
        method: "GET",
        credentials: "include",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          dispatch(userLogout());
        } catch (error) {
          console.log(error);
        }
      },
    }),
    changePassword: builder.mutation({
      query: (data) => ({
        url: "auth/changepassword",
        method: "POST",
        body: data,
        credentials: "include",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          // dispatch(userLogout());
        } catch (error) {
          console.log(error);
        }
      },
    }),
    updateUser: builder.mutation({
      query: (data) => ({
        url: "auth/updateUser",
        method: "POST",
        body: data,
        credentials: "include",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          dispatch(updateUser(arg));
        } catch (error) {
          console.log(error);
        }
      },
    }),


    updateUserById: builder.mutation({
      query: ({ id, data }) => ({
        url: "auth/updateUser/" + id,
        method: "PUT",
        body: data,
        credentials: "include",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          dispatch(updateUser(arg));
        } catch (error) {
          console.log(error);
        }
      },
    }),
    getUserById: builder.mutation({
      query: (userId) => ({
        url: "auth/user/" + userId,
        method: "GET",
        credentials: "include",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          // dispatch(updateUser(arg));
        } catch (error) {
          console.log(error);
        }
      },
    }),
    createAdmin: builder.mutation({
      query: (data) => ({
        url: 'auth/createAdmin',
        method: "POST",
        body: data,
        credentials: "include",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          // dispatch(updateUser(arg));
        } catch (error) {
          console.log(error);
        }
      },
    }),
    listAdmin: builder.mutation({
      query: (data) => ({
        url: 'auth/admin-list?' + data,
        method: "GET",
        credentials: "include",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          // dispatch(updateUser(arg));
        } catch (error) {
          console.log(error);
        }
      },
    }),
    getStatisticsUser: builder.query({
      query: (data) => ({
        url: 'auth/statistics/user',
        method: "GET",
        credentials: "include",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          // dispatch(updateUser(arg));
        } catch (error) {
          console.log(error);
        }
      },
    }),







  }),
});

export const {
  useRegisterMutation,
  useVerifyTokenMutation,
  useLoginMutation,
  useSocialLoginMutation,
  useLogoutMutation,
  useChangePasswordMutation,
  useUpdateUserMutation,
  useUpdateUserByIdMutation,
  useGetUserByIdMutation,
  useCreateAdminMutation,
  useListAdminMutation,
  useGetStatisticsUserQuery,
} = authApi;
